"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * HTML要素にクラス名を追加
 */
var Initialize = /** @class */ (function () {
    /**
     * コンストラクタ
     * @param isAdaptive アダプティブデザインかの真偽値
     * @param tabletViewport タブレットのviewport幅
     */
    function Initialize(isAdaptive, tabletViewport) {
        /**
         * ユーザーエージェント
         */
        this.ua = navigator.userAgent;
        /**
         * タブレットのviewport幅
         */
        this.tabletViewport = '';
        /**
         * クラス名
         */
        this.className = '';
        this.setHtmlClass();
        if (isAdaptive) {
            this.tabletViewport = tabletViewport;
            this.setTabletViewport();
        }
    }
    /**
     * HTML要素にクラス名を追加
     */
    Initialize.prototype.setHtmlClass = function () {
        //JavaScript有効判定
        this.className += ' js-available';
        //Retina判定
        if (window.devicePixelRatio > 1) {
            this.className += ' retina' + Math.round(window.devicePixelRatio);
        }
        // UA判定
        if (this.ua.match(/iPhone|iPad|iPod/i)) {
            this.className += ' ios';
            if (this.ua.match(/iPad/i)) {
                this.className += ' ipad';
            }
        }
        else if (this.ua.match(/Windows/i)) {
            this.className += ' win';
            if (this.ua.match(/rv:11/i)) {
                this.className += ' ie ie11';
                this.addPromise();
            }
        }
        else if (this.ua.match(/android/i)) {
            this.className += ' android';
        }
        else if (this.ua.match(/Macintosh/i)) {
            this.className += ' mac';
        }
        if (this.ua.match(/MSIE/i)) {
            this.className += ' ie';
            this.addPromise();
            if (this.ua.match(/MSIE 10/i)) {
                this.className += ' ie10';
            }
            else if (this.ua.match(/MSIE 9/i)) {
                this.className += ' ie9';
            }
            else if (this.ua.match(/MSIE 8/i)) {
                this.className += ' ie8';
            }
            else if (this.ua.match(/MSIE 7/i)) {
                this.className += ' ie7';
            }
            else if (this.ua.match(/MSIE 6/i)) {
                this.className += ' ie6';
            }
        }
        else if (this.ua.match(/AppleWebkit/i) && this.ua.match(/Edge/i)) {
            this.className += ' edge';
            this.addPromise();
        }
        else if (this.ua.match(/chrome/i)) {
            this.className += ' chrome';
        }
        else if (this.ua.match(/firefox/i)) {
            this.className += ' firefox';
        }
        else if (this.ua.match(/safari/i)) {
            this.className += ' safari';
        }
        // HTML要素にクラス名を追加
        document.getElementsByTagName('html')[0].className = this.className;
    };
    /**
     * タブレットの場合、viewportを変更
     */
    Initialize.prototype.setTabletViewport = function () {
        if (this.isTablet(this.ua)) {
            var meta = document.getElementsByTagName('meta');
            for (var i = 0; i < meta.length; i++) {
                var obj = meta[i];
                var name_1 = obj.getAttribute('name');
                if (name_1 && name_1.toLowerCase() == 'viewport') {
                    obj.setAttribute('content', 'width=' + this.tabletViewport);
                    break;
                }
            }
        }
    };
    /**
     * タブレットかどうかを調べる
     * @param ua ユーザーエージェントの文字列
     * @returns タブレットの場合true
     */
    Initialize.prototype.isTablet = function (ua) {
        if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
            return false;
        }
        else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
            return true;
        }
        return false;
    };
    /**
     * IEのPromise対応
     */
    Initialize.prototype.addPromise = function () {
        var script = document.createElement('script');
        script.setAttribute('src', 'https://www.promisejs.org/polyfills/promise-6.1.0.min.js');
        var head = document.querySelector('head');
        if (head) {
            head.appendChild(script);
        }
    };
    return Initialize;
}());
exports.Initialize = Initialize;
